module.exports = __webpack_public_path__ + "static/media/iot1.56abdb24.jpeg";